import LayoutModule from './LayoutModule';

export default LayoutModule;
